import { useQuery } from '@tanstack/react-query';
import { fetchSiteEquipment, type AnalyticsEquipment } from '@apis/analytics';

/**
 * Read the site's analytics equipment roster. Server resolves display
 * fields and sorts alphabetically — FE does not re-sort. Cache is keyed by
 * site so navigating between sites doesn't reuse stale rosters.
 */
export function useSiteEquipment(siteId: string | null | undefined) {
  return useQuery<AnalyticsEquipment[]>({
    queryKey: ['site', 'equipment', siteId],
    queryFn: ({ signal }) => fetchSiteEquipment(siteId!, signal),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
